import { Checkbox } from "antd";
import { useAdvancedFormContext } from "../advanced-form";
import { useCallback } from "react";


const days = ["Mo", "Di", "Mi", "Do", "Fr", "Sa", "So"];

function FormItemDaysOfWeek({ value, onChange, readOnly, disabled}: any) {
  const advancedFormContext = useAdvancedFormContext()
  const effectiveReadOnly = readOnly || advancedFormContext?.readOnly

  const isChecked = useCallback(d => (value || []).includes(d), [value])

  const setChecked = useCallback((d, checked) => {
    let newValue = value;
    if(checked && !(value || []).includes(d)) {
      newValue = [...(value || []), d];
    } else if(!checked) {
      newValue = (value || []).filter(d1 => d1 !== d);
    }
    onChange(newValue);
  }, [value, onChange])

  return <>
    
    
      <table>
        <tr>
          { days.map(d => <td style={{ textAlign: "center" }}>{ d.substring(0, 1) }</td>)}
        </tr>
        <tr>
          { days.map(d => <td><Checkbox disabled={effectiveReadOnly} checked={isChecked(d)} onChange={evt => setChecked(d, evt.target.checked)} /></td> ) }
        </tr>
      </table>
      
    
    </>
}

export default FormItemDaysOfWeek